import { useEffect } from "react";
import { History } from "lucide-react";
import { useGetSwapsQuery } from "../generated/graphql";
import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";
import { Button } from "./ui/button";
import { useToast } from "./ui/use-toast";
import { useAuth } from "../AuthProvider";
import { useNavigate } from "react-router-dom";
import { formatDate } from "../lib/formatDate";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "./ui/table";
import { formatNumberToString } from "../lib/formatNumbers";

export function HistoryCard() {
  const { organizationId } = useAuth();
  const navigate = useNavigate();
  const { toast } = useToast();

  const [{ data: swapsData, error: swapsError }] = useGetSwapsQuery({
    variables: { page: 0, organizationId },
    pause: organizationId === "" || !organizationId,
  });
  const swaps = swapsData?.getSwaps;

  useEffect(() => {
    if (swapsError) {
      toast({
        title: "Error",
        description: swapsError.message,
        variant: "destructive",
      });
    }
  }, [swapsError, toast]);

  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-lg font-semibold flex items-center">
          Recent Activity
          <History className="ml-2 h-4 w-4 opacity-50" />
        </CardTitle>
        <span>
          <Button
            style={{
              maxWidth: "100px",
            }}
            size="sm"
            variant="outline"
            onClick={() => {
              navigate("/history");
            }}
          >
            View All
          </Button>
        </span>
      </CardHeader>
      <CardContent>
        {swaps?.length === 0 ? (
          <div className="text-center m-6">No swaps found</div>
        ) : (
          <>
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead>Date</TableHead>
                  <TableHead>Currency</TableHead>
                  <TableHead>Amount</TableHead>
                  <TableHead>Currency</TableHead>
                  <TableHead>Amount</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {swaps?.slice(0, 5).map((swap, idx) => (
                  <TableRow
                    key={idx}
                    onClick={() => {
                      navigate(`/swaps/${swap.id}`);
                    }}
                  >
                    <TableCell style={{ textWrap: "nowrap" }}>
                      {formatDate(swap.date, "DD-MM-YYYY HH:mm")}
                    </TableCell>
                    <TableCell
                      style={{
                        display: "flex",
                        alignItems: "center",
                        marginRight: "10px",
                        textWrap: "nowrap",
                      }}
                    >
                      <img
                        src={swap.fromMint.img ?? ""}
                        alt={""}
                        className="w-6 h-6 mr-2"
                      />
                      {swap.fromMint.symbol}
                    </TableCell>
                    <TableCell>
                      {formatNumberToString(swap.fromAmount) ?? "N/A"}
                    </TableCell>
                    <TableCell
                      style={{
                        display: "flex",
                        alignItems: "center",
                        textWrap: "nowrap",
                      }}
                    >
                      <img
                        src={swap.toMint.img ?? ""}
                        alt={""}
                        className="w-6 h-6 mr-2"
                      />
                      {swap.toMint.symbol}
                    </TableCell>
                    <TableCell>
                      {formatNumberToString(swap.toAmount) ?? "N/A"}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </>
        )}
      </CardContent>
    </Card>
  );
}
